import React from 'react';
import {
    Checkbox,
} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import APP_ROUTES from '../../constants/app-routes';

module.exports = ({ onChange }) => (
    <Checkbox onChange={(e) => onChange(e.target.checked)} className="checkbox ">
        <FormattedMessage id="modal-kwallet-activate-accept" defaultMessage="Acepto los" />
        &nbsp;
        <Link to={APP_ROUTES.terms} target="_blank" className="modal-links"><FormattedMessage id="modal-kwallet-activate-terms" defaultMessage="Terminos y condiciones" /></Link>
        &nbsp;
        <FormattedMessage id="modal-kwallet-activate-and" defaultMessage="y" />
        &nbsp;
        <Link to={APP_ROUTES.affidavitCertification} target="_blank" className="modal-links"><FormattedMessage id="modal-kwallet-activate-affidavit" defaultMessage="Affidavit Certification" /></Link>
    </Checkbox>
);



/** WEBPACK FOOTER **
 ** ./src/components/shared/checkbox-terms-affidavit.jsx
 **/